// extracted by mini-css-extract-plugin
export default {"container":"Table_container__p6wIK","scrollBox":"Table_scrollBox__4DzkS"};